import BaseEntity from "./base.entity";
import uuid from "uuid";

export default class OptionalGroup extends BaseEntity {
  defaultParams() {
    return {
      uuid: uuid(),
      name: "",
      enabled: true,
      limited: false,
      limited_value: "",
      optionals: [],
      mandatory: false,
      mandatory_quantity: "",
      value: ""
    };
  }

  identifier() {
    return this.name || "Grupo de Opcionais não identificado";
  }
}



// WEBPACK FOOTER //
// ./src/core/entity/optional-group.entity.js